import React, { useState } from "react";
import { AiFillMail } from "react-icons/ai";
import '../Styles/Footer.css';

export default function Footer() {
  const [isCopied, setIsCopied] = useState(false);

  const copy = (info) => {
    navigator.clipboard.writeText(info)
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1500)
  }

    return (
      <footer className="footer">
        {
          isCopied && ( <div className="copy-content">Copiado!</div> )
        }
        <div className="info-content">
          <div className="creator">
            <p>© Copyright - Lucas Ch. 2023</p>
          </div>
          <div className="mail-content" onClick={ () => copy('lucaschmain@gmail.com') }>
            <AiFillMail fontSize="30px"/>
            <p>lucaschmain@gmail.com</p>
          </div>
        </div>
      </footer>
    )
}
